// 购物车表单提交前处理discount参数
jQuery_T4NT(document).ready(function($) {

    // 监听购物车表单的提交事件
    $('body').on('submit', '.frm_cart_page', function(e) {
        var form = $(this);
        var discountInput = form.find('input[name="discount"]');
        
        // 检查discount输入框是否存在且值为空
        if (discountInput.length > 0 && $.trim(discountInput.val()) === '') {
            // 临时移除name属性，这样该字段就不会被包含在表单提交中
            discountInput.removeAttr('name');
            
            // 在表单提交完成后恢复name属性（用于后续可能的操作）
            setTimeout(function() {
                discountInput.attr('name', 'discount');
            }, 100);
        }
    });
    
    // 针对结账按钮的特殊处理（如果有AJAX提交逻辑）
    $('body').on('click', 'button[name="checkout"]', function(e) {
        var form = $(this).closest('form');
        var discountInput = form.find('input[name="discount"]');
        
        if (discountInput.length > 0 && $.trim(discountInput.val()) === '') {
            discountInput.removeAttr('name');
            
            // 延迟恢复name属性
            setTimeout(function() {
                discountInput.attr('name', 'discount');
            }, 100);
        }
    });
});
